<template>
  <svg
    width="19.31"
    height="19.31"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="#FFF"
      fill-rule="evenodd"
    >
      <path d="M11.083 11.326v-5.45a.764.764 0 0 0-1.178-.641L4.667 9.347v-.015H2.255A2.256 2.256 0 0 0 0 11.588v4.822a2.255 2.255 0 0 0 2.255 2.255H4.44l5.482 4.056a.763.763 0 0 0 1.161-.651v-5.786a2.479 2.479 0 1 0 0-4.958m9.678 2.479a8.502 8.502 0 0 0-5.197-7.842 1.168 1.168 0 0 0-.909 2.149 6.172 6.172 0 0 1 3.773 5.693 6.148 6.148 0 0 1-3.905 5.747 1.168 1.168 0 0 0 .861 2.169 8.47 8.47 0 0 0 5.377-7.916"/>
      <path d="M18.36.092a1.167 1.167 0 0 0-.909 2.149 12.5 12.5 0 0 1 7.647 11.536 12.46 12.46 0 0 1-7.91 11.646 1.166 1.166 0 1 0 .858 2.169c5.702-2.258 9.385-7.68 9.385-13.815 0-5.982-3.56-11.355-9.07-13.685"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AudioIcon',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/icons/AudioIcon.vue